// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_tilda_cutouts: MapboxStyleLayer[] = [
  {
    id: 'cutout-base',
    type: 'fill',
    paint: {
      'fill-color': 'rgba(80, 139, 134, 0.7)',
      'fill-opacity': 0.56,
    },
  },
  {
    id: 'cutout-category-ring',
    type: 'line',
    minzoom: 16.5,
    paint: {
      'line-color': [
        'match',
        ['get', 'category'],
        ['bus_stop', 'bus_stop_conditional'],
        'hsla(48, 96%, 53%, 0.7)',
        [
          'mobility_hub',
          'bicycle_rental',
          'motorcycle_parking',
          'small_electric_vehicle_parking',
          'bicycle_parking',
          'parklet',
        ],
        'hsla(0, 92%, 34%, 0.59)',
        [
          'street_lamp',
          'tree',
          'street_cabinet',
          'advertising',
          'bollard',
          'recycling',
          'vending_parking_tickets',
        ],
        'hsla(242, 39%, 31%, 0.88)',
        [
          'crossing_zebra',
          'crossing_marked',
          'crossing_buffer_marking',
          'traffic_calming_choker',
          'crossing_traffic_signals',
          'crossing_kerb_extension',
        ],
        'hsla(133, 65%, 35%, 0.73)',
        ['driveway', 'loading_ramp'],
        'hsla(270, 29%, 38%, 0.61)',
        [
          'road_marking_restricted_area',
          'turning_circle',
          'kerb_lowered',
          'parking_kerb',
          'barrier',
          'turning_loop',
        ],
        'hsla(206, 62%, 31%, 0.6)',
        'hsla(0, 71%, 0%, 0)',
      ],
      'line-width': 5,
      'line-offset': 2.5,
    },
    layout: {
      'line-join': 'round',
    },
  },
  {
    id: 'cutout-border',
    type: 'line',
    minzoom: 16.5,
    paint: {
      'line-dasharray': [2, 2],
      'line-color': 'hsl(175, 27%, 43%)',
    },
    layout: {
      'line-join': 'round',
    },
  },
]
